import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  announcement: Announcement;
}


import { ref, computed } from 'vue';

import { modals } from '@modals';

export interface Announcement {
  title: string;
  details?: string;
}

const __default__ = { name: 'SiteAnnouncement' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    announcement: null
  },
  setup(__props: any) {

const props = __props as {
  announcement: Announcement;
};

/**
 * `SiteAnnouncement` component properties.
 */


const dismissed = ref(false);

const title = computed(() => {
  return props.announcement?.title ? props.announcement.title : null;
});
const details = computed(() => {
  return props.announcement?.details ? props.announcement.details : null;
});

async function showDetails() {
  if (!details.value || typeof details.value !== 'string') return;

  const options = {
    title: 'Maintenance Nov. 19-20',
    text: details.value,
  };

  await modals.util.generalInfo(options);
}

return { __sfc: true,props, dismissed, title, details, showDetails }
}

})